import { defineComponent as _defineComponent } from 'vue'
import FileWrapperMultiView from './FileWrapperMultiView.vue';
import { ref } from 'vue';
import { Tooltip } from 'element-ui';



export default /*#__PURE__*/_defineComponent({
  __name: 'FileWrapperMultiViewButton',
  props: {
    patentId: {
        type: String,
        required: true,
    },
    isBeta: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {



const showFileWrapperMultiView = ref(false);
const triggerMultiView = (val: boolean) => {
    showFileWrapperMultiView.value = val;
};


return { __sfc: true,showFileWrapperMultiView, triggerMultiView, FileWrapperMultiView, Tooltip }
}

})